// Mirrors CodeSwitch.Utils.EmailQueuer's EmailTaskStatus (Pending=0, Sending=1, Sent=2, Error=3,
// PermanentlyFailed=4). Values are the NAMES, not the ordinals: MVC serializes with Newtonsoft and a
// StringEnumConverter (Program.cs), so the wire carries "PermanentlyFailed", not 4.
// CO-231: `PermanentlyFailed` was missing here, so every retry-exhausted row (245 of them on prod)
// rendered as "Unknown" on the System Emails screen and could not be selected — which also meant the
// Operator could NOT force a stuck `Sending` row terminal, the one manual lever that unwedges the queue.
export enum EmailTaskStatus {
    Pending = "Pending",
    Sending = "Sending",
    Sent = "Sent",
    Error = "Error",
    PermanentlyFailed = "PermanentlyFailed",
}

export interface EmailQueuerTask {
    id: number;
    to: string;
    cc: string;
    bcc: string;
    attachmentPaths: string;
    subject: string;
    modelJson: string;
    template: string;
    modelType: string;
    status: EmailTaskStatus;
    createdOn: Date;
    sentOn: Date;
}
